<template>
  <div>
    <p v-if="!notShowTips">{{ tipsText }}</p>
    <el-checkbox
      label=""
      :true-label="bidType"
      v-model="bidStrategy"
      @change="(val) => setVal('setBidType', val)"
      >{{ checkboxLabel }}</el-checkbox
    >
    <div
      v-if="bidStrategy"
      style="margin-top: 10px"
      class="relative"
    >
      <el-input
        v-model="bidAmount"
        v-to-fixed="2"
        :placeholder="isRoas ? '填写目标ROAS' : '填写出价金额'"
        style="width: 300px"
        type="number"
        @change="(val) => setVal('setBidAmount', val)"
        @blur="validateBidAmount"
        :class="{ 'is-error': hasError }"
      >
        <span slot="append">{{ appendText }}</span>
      </el-input>
      <div
        v-if="errorMessage"
        style="color: #f56c6c; font-size: 12px"
        class="absolute mt-[-5px]"
      >
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    currentAccount: Object,
    notShowTips: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bidAmount: '',
      bidStrategy: null,
      errorMessage: '',
      hasError: false,
    };
  },
  computed: {
    // 判断广告系列出价策略是否为 ROAS
    isRoas() {
      return ['TARGET_ROAS', 'MAX_CONVERSION_VALUE'].includes(this.value?.campaignBidStrategy);
    },
    // 当前出价类型
    bidType() {
      return this.isRoas ? 'TARGET_ROAS' : 'TARGET_CPA';
    },
    // 验证范围
    checkData() {
      if (this.isRoas) {
        return { bidMin: 0.01, bidMax: 1000 };
      }
      return { bidMin: 0.01, bidMax: 1000000 };
    },
    currency() {
      return this.currentAccount?.currency || 'USD';
    },
    // 输入框后缀文案
    appendText() {
      return this.isRoas ? '%' : `${this.currency}/转化`;
    },
    // 提示文案
    tipsText() {
      if (this.isRoas) {
        return '除非您决定专门为某个广告组设置目标ROAS，否则此广告组将使用广告系列级目标ROAS。';
      }
      return '除非您决定专门为某个广告组设置目标每次转化费用，否则此广告组将使用广告系列级目标每次转化费用。';
    },
    // checkbox 文案
    checkboxLabel() {
      if (this.isRoas) {
        return '设置广告组目标ROAS（未设置出价，默认广告系列出价）';
      }
      return '设置广告组目标出价（未设置出价，默认广告系列出价）';
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.bidAmount = newVal.bidAmount;
        this.bidStrategy = newVal.bidStrategy;
      },
      deep: true,
      immediate: true,
    },
    // 当系列出价策略变化时，重置广告组出价
    isRoas(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.bidStrategy = null;
        this.bidAmount = null;
        this.clearError();
        this.$emit('input', { bidAmount: null, bidStrategy: null });
      }
    },
  },
  methods: {
    setVal(key, val) {
      if (key == 'setBidType' && !val) {
        this.bidStrategy = null;
        this.bidAmount = null;
        this.clearError();
      }
      // 将出价金额截断为两位小数，确保界面显示和实际提交值一致
      let finalBidAmount = this.bidAmount;
      if (finalBidAmount !== null && finalBidAmount !== '' && finalBidAmount !== undefined) {
        finalBidAmount = Math.floor(Number(finalBidAmount) * 100) / 100;
      }
      this.$emit('input', {
        bidAmount: finalBidAmount ? Number(finalBidAmount) : finalBidAmount,
        bidStrategy: this.bidStrategy,
      });
    },
    validateBidAmount() {
      const currentBidType = this.bidType;
      if (this.bidStrategy === currentBidType) {
        if (!this.bidAmount || this.bidAmount.toString().trim() === '') {
          this.errorMessage = this.isRoas
            ? '当选择设置广告组目标ROAS时，目标ROAS必填'
            : '当选择设置广告组目标出价时，出价金额必填';
          this.hasError = true;
          return false;
        }
        const numValue = Math.floor(Number(this.bidAmount) * 100) / 100;
        if (numValue < this.checkData.bidMin) {
          this.errorMessage = this.isRoas
            ? `目标ROAS必须大于等于${this.checkData.bidMin}`
            : `出价金额必须大于${this.checkData.bidMin}`;
          this.hasError = true;
          return false;
        }
        if (numValue > this.checkData.bidMax) {
          this.errorMessage = this.isRoas
            ? `目标ROAS必须小于等于${this.checkData.bidMax}`
            : `出价金额必须小于${this.checkData.bidMax}`;
          this.hasError = true;
          return false;
        }
        // 同步更新 bidAmount 为截断后的值
        this.bidAmount = numValue;
        this.$emit('input', { bidAmount: numValue, bidStrategy: this.bidStrategy });
      }
      this.clearError();
      return true;
    },
    clearError() {
      this.errorMessage = '';
      this.hasError = false;
    },
    validate() {
      return this.validateBidAmount();
    },
  },
  mounted() {
    this.bidAmount = this.value.bidAmount;
  },
};
</script>
<style lang="scss" scoped></style>
